/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import {
    ControlledMenu, MenuItem, useMenuState,
} from "@szhsin/react-menu";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PTMButton from "./PTMButton";

function PTMMenuButton(props) {
    const {
        title, menuItems, color, icon,
    } = props;

    const [menuProps, toggleMenu] = useMenuState();
    const menuRef = React.useRef(null);
    return (
        <>
            <PTMButton
                variant="contained"
                color={color}
                onClick={() => toggleMenu(true)}
                buttonRef={menuRef}
                icon={icon}
            >
                {title}
            </PTMButton>
            <ControlledMenu
                {...menuProps}
                anchorRef={menuRef}
                portal
                direction="bottom"
                onClose={() => toggleMenu(false)}
            >
                {
                    menuItems?.map((item) => (
                        !item.hide && (
                            <div style={{ display: "flex", alignItems: "center", paddingLeft: "5px" }}>
                                {" "}
                                <FontAwesomeIcon icon={item.icon} />
                                {" "}
                                <MenuItem onClick={() => item.action()}>{item.title}</MenuItem>
                                {" "}
                            </div>
                        )
                    ))
                }

            </ControlledMenu
            >

        </>
    );
}

export default PTMMenuButton;
